import SEO from "@/components/SEO";
import type { OrganizationSchema } from "@/types";

const Impressum: React.FC = () => {
	const schema: OrganizationSchema = {
		"@context": "https://schema.org",
		"@type": "WebPage",
		name: "Impressum - WILDFÖRSTER Fahrzeugaufbereitung",
		description: "Impressum der WILDFÖRSTER Fahrzeugaufbereitung in Wuppertal",
		url: "https://aufbereitung-wuppertal.de/impressum",
		logo: "https://aufbereitung-wuppertal.de/logo192.png",
		telephone: "+49-170-3571907",
		email: "daniel.wildfoerster@gmail.com",
		address: {
			"@type": "PostalAddress",
			streetAddress: "Große Haken Straße 42",
			addressLocality: "Wuppertal",
			postalCode: "42283",
			addressCountry: "DE",
		},
		sameAs: [
			"https://m.facebook.com/Daniel-Wildf%C3%B6rster-113290246971839/",
			"https://www.instagram.com/wildforsterdaniel/",
			"https://www.tiktok.com/@wildfoerster13",
		],
	};

	return (
		<>
			<SEO
				title="Impressum"
				description="Impressum der WILDFÖRSTER Fahrzeugaufbereitung in Wuppertal. Kontaktdaten und rechtliche Informationen."
				canonical="https://aufbereitung-wuppertal.de/impressum"
				schema={schema}
			/>
			<main className="min-h-screen bg-black text-white py-20 pt-32">
				<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
					<h1 className="text-4xl md:text-5xl font-bold mb-8">Impressum</h1>

					<div className="space-y-8 text-lg">
						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								Angaben gemäß § 5 TMG
							</h2>
							<div className="space-y-2">
								<p>
									<strong>Daniel Wildförster</strong>
								</p>
								<p>WILDFÖRSTER Fahrzeugaufbereitung</p>
								<p>Große Haken Straße 42</p>
								<p>42283 Wuppertal</p>
								<p>Deutschland</p>
							</div>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								Kontakt
							</h2>
							<div className="space-y-2">
								<p>
									Telefon:{" "}
									<a
										href="tel:01703571907"
										className="text-[#cfc297] hover:underline"
									>
										0170 3571907
									</a>
								</p>
								<p>
									E-Mail:{" "}
									<a
										href="mailto:daniel.wildfoerster@gmail.com"
										className="text-[#cfc297] hover:underline"
									>
										daniel.wildfoerster@gmail.com
									</a>
								</p>
							</div>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								Verantwortlicher
							</h2>
							<p>
								Inhaltlich Verantwortlicher gemäß § 18 Abs. 2 MStV:{" "}
								<strong>Daniel Wildförster</strong>
							</p>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								Hinweise
							</h2>
							<div className="text-white/80 space-y-4 leading-relaxed">
								<p>
									Kleinunternehmer i. S. v. § 19 Abs. 1 UStG haben ein
									Wahlrecht, ob sie Umsatzsteuer abführen wollen. Entscheiden
									sie sich gegen die Abführung, benötigen sie grundsätzlich
									keine Umsatzsteuer-Identifikationsnummer.
								</p>
								<p>
									Verfügen sie über keine Umsatzsteuer-Identifikationsnummer,
									müssen sie auch im Impressum keine solche angeben. Hinzu
									kommt, daß Kleinunternehmer häufig nicht ins Handelsregister
									eingetragen sind, so daß auch insoweit keine Angaben
									erforderlich sind.
								</p>
								<p>
									Besteht allerdings eine Registereintragung oder wurde eine
									Umsatzsteuer-Identifikationsnummer erteilt, sind die
									entsprechenden Angaben zu machen. Das Muster geht davon aus,
									daß keine Umsatzsteuer-Identifikationsnummer vorliegt und daß
									der Betreiber der Internetseite nicht ins Handelsregister
									eingetragen ist.
								</p>
							</div>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								Streitschlichtung
							</h2>
							<p className="text-white/80">
								Die Europäische Kommission stellt eine Plattform zur
								Online-Streitbeilegung (OS) bereit:{" "}
								<a
									href="https://ec.europa.eu/consumers/odr"
									target="_blank"
									rel="noopener noreferrer"
									className="text-[#cfc297] hover:underline"
								>
									https://ec.europa.eu/consumers/odr
								</a>
								.<br />
								Wir sind nicht bereit oder verpflichtet, an
								Streitbeilegungsverfahren vor einer
								Verbraucherschlichtungsstelle teilzunehmen.
							</p>
						</section>
					</div>
				</div>
			</main>
		</>
	);
};

export default Impressum;
